var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { collectionEngine, collectionEngineV1 } from '../apis';
const templatesAPI = collectionEngine('/templates');
const templatesApiV1 = collectionEngineV1('/templates');
export const getAll = () => templatesApiV1('GET', '/');
export const del = (templateId) => templatesApiV1('DELETE', '/all/' + templateId);
export const create = (template) => templatesApiV1('POST', '', {
    body: template,
});
export const getTemplate = (templateId, ac, lang, includeUnpublished) => __awaiter(void 0, void 0, void 0, function* () {
    return templatesApiV1('GET', '/' +
        templateId +
        '/' +
        ac +
        `?lang=${lang}${includeUnpublished ? `&includeUnpublished=${includeUnpublished}` : ''}`);
});
export const saveDraft = (template) => __awaiter(void 0, void 0, void 0, function* () {
    return templatesApiV1('POST', '/save-draft', {
        body: template,
    });
});
export const publishVersion = (versionId, ac, isDefaultLang) => __awaiter(void 0, void 0, void 0, function* () {
    return templatesApiV1('POST', '/publish-version', {
        body: {
            versionId,
            ac,
            isDefaultLang,
        },
    });
});
export const getTemplateVersions = (templateId, ac, lang) => __awaiter(void 0, void 0, void 0, function* () {
    return templatesApiV1('POST', '/versions', { body: { templateId, ac, lang } });
});
export const deleteTemplateVersion = (versionId, ac) => __awaiter(void 0, void 0, void 0, function* () {
    return templatesApiV1('DELETE', '/version/' + versionId + '/' + ac);
});
export const genLetterPDF = (templateId, caseId, data, fileName) => __awaiter(void 0, void 0, void 0, function* () {
    return templatesAPI('GET', `/to-file${genLetterUrl(templateId, caseId, data, fileName)}`);
});
const DEFAULT_FILE_NAME = 'attachment.pdf';
export const genLetterUrl = (templateId, caseId, data, fileName) => `/${fileName || DEFAULT_FILE_NAME}?content=${encodeURIComponent(JSON.stringify({
    templateId,
    caseId,
    data,
    fileName: fileName || DEFAULT_FILE_NAME,
}))}`;
export const patch = (templateId, patch) => __awaiter(void 0, void 0, void 0, function* () {
    return templatesApiV1('PATCH', '/' + templateId, {
        body: patch,
    });
});
//# sourceMappingURL=templates.js.map